import React, { useState } from "react";

const SyllabusTracker = () => {
  const [completed, setCompleted] = useState("");
  const [total, setTotal] = useState("");
  const [progress, setProgress] = useState(null);

  const calculateProgress = () => {
    setProgress(((completed / total) * 100).toFixed(2));
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Syllabus Completion Tracker</h2>
      <input type="number" placeholder="Completed Topics" className="border p-2 w-full mt-3" onChange={(e) => setCompleted(e.target.value)} />
      <input type="number" placeholder="Total Topics" className="border p-2 w-full mt-3" onChange={(e) => setTotal(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateProgress}>Calculate</button>
      {progress && <div className="mt-3 text-center text-lg">Progress: <span className="font-bold text-green-600">{progress}%</span></div>}
    </div>
  );
};

export default SyllabusTracker;
